const initialState = {};
import * as Constants from '../constants';

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.FETCH_DELIVERED_ORDERS_START:
      return Object.assign({}, state, {
        loading: true
      });
    case Constants.FETCH_DELIVERED_ORDERS_SUCCESS:
      return Object.assign({}, state, {
        loading: false
      });
    case Constants.FETCH_DELIVERED_ORDERS_FAILURE:
      return Object.assign({}, state, {
        loading: false
      });
    default:
      return { ...state };
  }
}
